import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";

import { OveraBaseModule } from "@overa/base";

//TODO: Using local modules of some overa components. When the components are moved to the shared library, use from there.
//import { OveraButtonModule } from "@overa/components/button";
//import { OveraButtonTieredMenuModule } from "@overa/components/button-tiered-menu";
import { OveraCheckboxModule } from "@overa/components/checkbox";
import { OveraEchartModule } from "@overa/components/echart";
//import { OveraEchartModule } from "../shared/echart/overa-echart.module";
import { OveraFilterTextModule } from "@overa/components/filter-text";
import { OveraMultiSelectModule } from "@overa/components/multiselect";
import { OveraTextAreaModule } from "@overa/components/text-area";
import { OveraToggleButtonModule } from "@overa/components/toggle-button";
import { OveraTreeTableModule } from "@overa/components/treetable";
import { OveraInputModule } from "@overa/components/input";

import { OveraDataTableModule } from "@overa/components/datatable";
import { OveraDatepickerModule } from "@overa/components/datepicker";
import { SecurityModule } from "@overa/security";
import { AutoTracingModule, DynamicPipeModule, ObservableService, OveraUtils } from "@overa/shared";
import { OveraChipsModule } from "@overa/components/chips";
import { NgxSpinnerModule } from "ngx-spinner";
import { OveraRadioButtonModule } from "@overa/components/radiobutton";
import { OveraTabViewModule } from "@overa/components/tabview";
import { OveraMasterDetailModule } from "@overa/components/master-detail";
import { OveraButtonModule } from "@overa/components/button";
import { OveraButtonTieredMenuModule } from "@overa/components/button-tiered-menu";
import { OveraDropdownModule } from "@overa/components/dropdown";
import { OveraFilterModule } from "@overa/components/filter";
import { OveraSuperDatepickerModule } from "@overa/components/superdatepicker";

//import { OveraChipsObjectModule } from "@overa/components/chips-object";

@NgModule({
  imports: [
    OveraBaseModule,
    SecurityModule,
    // SidebarModule,
    OveraCheckboxModule,
    OveraButtonModule,
    OveraEchartModule,
    OveraToggleButtonModule,
    OveraButtonTieredMenuModule,
    DynamicPipeModule,
    OveraFilterTextModule,
    OveraTextAreaModule,
    OveraTreeTableModule,
    OveraMultiSelectModule,
    OveraDropdownModule,
    OveraDatepickerModule,
    OveraDataTableModule,
    OveraInputModule,
    OveraChipsModule,
    NgxSpinnerModule,
    OveraTabViewModule,
    //OveraChipsObjectModule,
    OveraMasterDetailModule,
    OveraFilterModule,
    OveraSuperDatepickerModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [OveraUtils, ObservableService],
  exports: [
    OveraBaseModule,
    SecurityModule,
    // SidebarModule,
    OveraCheckboxModule,
    OveraButtonModule,
    OveraEchartModule,
    OveraToggleButtonModule,
    OveraButtonTieredMenuModule,
    DynamicPipeModule,
    OveraFilterTextModule,
    OveraTextAreaModule,
    OveraTreeTableModule,
    OveraMultiSelectModule,
    OveraDropdownModule,
    OveraDatepickerModule,
    OveraDataTableModule,
    OveraInputModule,
    OveraChipsModule,
    OveraTabViewModule,
    //OveraChipsObjectModule,
    OveraMasterDetailModule,
    OveraSuperDatepickerModule
  ],
})
export class OveraModule { }
